import { AppInsights } from '@/appInsights';
import { CMPApi } from '@/modules/cmp-api';
import { EventEmitter } from 'events';
import moment from 'moment';
import { Options, Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import UserDefine from '../../assets/config/user-define.json';
@Options({})
export default class PageFooter extends Vue {
  @Inject({ from: 'apiService', default: new CMPApi() })
  private apiService!: CMPApi;

  @Inject({ from: 'eventController', default: new EventEmitter })
  private eventCtrl!: EventEmitter;

  private ai = new AppInsights;
  private baseDate: any = {};

  mounted(): void {
    this.loadBaseDate();
  }

  get termsUrl(): string {
    return UserDefine[0].terms_url;
  }
  get privacyUrl(): string {
    return UserDefine[0].privacy_url;
  }

  get currentYear(): string {
    let year: string;
    try {
      if (this.baseDate !== null && this.baseDate?.baseDateUtc) {
        year = moment(this.baseDate.baseDateUtc).format('YYYY');
      } else {
        year = '2021';
      }
      
    } catch {
      year = '2021';
    }
    return (year !== '2021' ? '2021 - ' + year : '2021'); 
  }

  private loadBaseDate(): void {
    this.apiService.systemApi?.apiV1SystemGetBaseDateUtcGet()
      .then((res: any) => {
        this.baseDate = res.data;
      })
      .catch((err) => {
        // this.eventCtrl.emit('show-snackbar', 'error', 'Error getting system date: ' + !!err.response?.status ? err.response?.status : err);
        this.ai.trackException('Error getting system date: ' + err);
      })
  }

  private logoClick() {
    window.open('https://www.lawsociety.com.au/', 'blank');
  }

}
